import { UseFormRegister } from "react-hook-form";

export default function CheckboxField({
  label,
  name,
  id,
  fieldOptions,
  register,
}: {
  label?: string;
  name: string;
  id?: string;
  fieldOptions: {
    name: string;
    id?: string;
    label: string;
    brief?: string;
  }[];
  register: UseFormRegister<any>;
}) {
  return (
    <>
      <label htmlFor={name} className="block text-sm font-medium text-gray-700">
        {label}
      </label>
      <fieldset className="space-y-2">
        <legend className="sr-only">{label}</legend>
        {fieldOptions.map((option) => (
          <div key={option.label} className="relative flex items-start">
            <div className="flex items-center h-5">
              <input
                id={option.id}
                type="checkbox"
                aria-describedby={option.name}
                className="focus:ring-primaryColor-normal h-4 w-4 text-indigo-600 border-gray-300 rounded-md"
                value={option.label}
                {...register(name)}
              />
            </div>
            <div className="ml-3 text-sm">
              <label htmlFor={option.id} className="font-medium text-gray-700">
                {option.label}
              </label>
              <p id={option.id} className="text-gray-500">
                {option.brief}
              </p>
            </div>
          </div>
        ))}
      </fieldset>
    </>
  );
}
